import { DndContext, DragOverlay } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useBasicDndDragger } from '@framework/engine';
import { useRelationEditor } from '@framework/form';
import { Typography } from 'antd';
import * as React from 'react';
import { IMapLayer, MapLayerType } from '../layers/MapLayer';
import { MapLayerConfigDrawerButton } from './MapLayerConfigDrawerButton';
import { MapLayerItem } from './MapLayerItem';
import { MapLayerSortableItem } from './MapLayerSortableItem';

export interface IMapLayersConfigSectionProps {
  name: string;
  allowedTypes?: MapLayerType[];
}

export function MapLayersConfigSection(props: IMapLayersConfigSectionProps) {
  const { name } = props;

  const editor = useRelationEditor<IMapLayer>(name);
  const { sensors, handleDragStart, handleDragEnd, itemIds, active } =
    useBasicDndDragger(editor);

  return (
    <div>
      <Typography.Paragraph>
        Il livello che appare per primo è quello più in basso, ovvero il livello
        di <b>sfondo</b>.
      </Typography.Paragraph>
      <DndContext
        sensors={sensors}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
          {editor.items.map((item, i) => (
            <MapLayerSortableItem
              index={item.__uid!}
              key={item.__uid}
              layer={item}
              configMode
              onEdit={e => {
                e.preventDefault();
                e.stopPropagation();

                editor.handle.open(item);
              }}
              onRemove={e => {
                e.preventDefault();
                e.stopPropagation();
                editor.removeAt(i);
              }}
            />
          ))}

          <DragOverlay>
            {active && <MapLayerItem layer={active} isDragging />}
          </DragOverlay>
        </SortableContext>
      </DndContext>
      <MapLayerConfigDrawerButton
        editor={editor}
        allowedTypes={props.allowedTypes}
      />
    </div>
  );
}
